// PLUGINS IMPORTS //
import React, { memo } from "react"
import styled from "styled-components/macro"

// COMPONENTS IMPORTS //
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //
import { iPadResolution } from "Content/Shared/Styles/Theme"

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  open: boolean
  setOpen: (open: boolean) => void
}

const BurgerButton: React.FC<PropsType> = (props) => {
  return (
    <Wrapper open={props.open} onClick={() => props.setOpen(!props.open)}>
      <div />
      <div />
      <div />
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const SIZE = "1.6rem"
const Wrapper = styled.div`
  width: ${SIZE};
  height: ${SIZE};

  position: absolute;
  top: 20px;
  right: 25px;

  z-index: 20;
  display: none;

  @media (max-width: ${iPadResolution}px) {
    display: flex;
    justify-content: space-around;
    flex-flow: column nowrap;
  }

  div {
    width: 2rem;
    height: 0.2rem;
    background-color: ${({ open }: { open: boolean }) =>
      open ? "black" : "rgba(255, 255, 255, 0.4)"};
    border-radius: 10px;
    transform-origin: 1px;
    transition: all 0.3s linear;

    &:nth-child(1) {
      transform: ${({ open }: { open: boolean }) =>
        open ? "rotate(45deg)" : "rotate(0)"};
    }

    &:nth-child(2) {
      transform: ${({ open }: { open: boolean }) =>
        open ? "translateX(100%)" : "translateX(0))"};
      opacity: ${({ open }: { open: boolean }) => (open ? 0 : 1)};
    }

    &:nth-child(3) {
      transform: ${({ open }: { open: boolean }) =>
        open ? "rotate(-45deg)" : "rotate(0)"};
    }
  }
`
export default memo(BurgerButton, memoComparison)
